import { gql } from '@apollo/client';

export const GET_COMPANY_MEMBERS = gql`
  query GetCompanyMembers {
    getCompanyMembers {
      id
      firstName
      lastName
      email
      role
      status
    }
  }
`;

export const GET_USER_METRIC_PERMISSIONS = gql`
  query GetUserMetricPermissions {
    getUserMetricPermissions {
      id
      metricKey
      connectorType
      isEnabled
      createdAt
      updatedAt
      user {
        id
        firstName
        lastName
        email
      }
      grantedBy {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_USER_METRIC_PERMISSIONS_BY_USER_ID = gql`
  query GetUserMetricPermissionsByUserId($userId: String!) {
    getUserMetricPermissionsByUserId(userId: $userId) {
      id
      metricKey
      connectorType
      isEnabled
      createdAt
      updatedAt
      user {
        id
        firstName
        lastName
        email
      }
      grantedBy {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_MY_METRIC_PERMISSIONS = gql`
  query GetMyMetricPermissions {
    getMyMetricPermissions {
      id
      metricKey
      connectorType
      isEnabled
      createdAt
      updatedAt
      grantedBy {
        id
        firstName
        lastName
      }
    }
  }
`;
